import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Button } from 'src/common/button';
import { JourneyFormik, JourneyForm } from 'src/common/JourneyFormik';
import { FormikTextInput } from 'src/common/form/formik/text-input';
import { NDA_TEMPLATE_URL } from 'src/utils/copy';
import FontFaceObserver from "fontfaceobserver"

interface EmbedPlayerNdaGatingProps {
  email: string;
  onSignNdaClick: (email: string, signature: string) => void;
  containerClass: string;
}

export const EmbedPlayerNdaGating: React.FC<EmbedPlayerNdaGatingProps> = ({
  email,
  onSignNdaClick,
  containerClass,
}) => {
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    new FontFaceObserver('Caveat', {
      weight: 400
    }).load().then(() => {
      setFontLoaded(true);
    }).catch(() => {
      setFontLoaded(true);
    })
  }, []);
  const formikParams = {
    initialValues: {
      signature: '',
    },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: Yup.object().shape({
      signature: Yup.string().required('Please type your full name to sign'),
    }),
    onSubmit: (values: any) => {
      onSignNdaClick(email || '', values.signature);
    }
  };

  return (
    <div className={containerClass}>
      <div className="flex flex-col space-y-4 text-bedrock-black">
        <div className='text-bedrock-h2'>
          This Journey requires a non-disclosure agreement. Type your full name to sign and proceed
        </div>
        <JourneyFormik {...formikParams} 
          render={(formProps: any) => (
          <JourneyForm>
            <FormikTextInput
              id='nda-signature'
              name='signature'
              placeholder='Full name'
              required={true}
              autoFocus={true}
              className='w-full'
              showBorder={false}
              style={{
                fontFamily: "'Caveat', cursive",
                lineHeight: '56px',
                fontWeight: 400,
                fontSize: 30,
                opacity: fontLoaded ? 1 : 0,
              }} />
              <div className='text-bedrock-p-small mt-4'>
                A signed copy will be emailed to you. By signing you agree to use electronic records and signatures and to the Journey <a href="https://www.journey.io/terms" className="underline" target="_blank" rel="noopener noreferrer">Terms of Service.</a>
              </div>
              <div className="flex self-start space-x-2 mt-6">
                <Button
                  variant='primary'
                  label='Sign and proceed'
                  size='regular'
                  type='submit'
                  disabled={formProps.values.signature === ''}
                />
                <a href={NDA_TEMPLATE_URL} target="_blank" rel="noopener noreferrer">
                  <Button
                    variant='secondary'
                    label='View document'
                    size='regular'
                  />
                </a>
              </div>
          </JourneyForm>
          )} />
      </div>
    </div>
  );
}